import { useState } from 'react';
import { NOMBRE_DE_RUBRO } from '../panel/lib/rubros.js';
import { linkDeMapa } from '../lib/mapa.js';
import { MarcoDeMapa } from './Mapa.jsx';

/**
 * El header lleva el nombre del NEGOCIO, no el de la plataforma. Quien entra
 * viene del Instagram de la barbería: si arriba dice otra cosa, duda.
 * La marca de HolaTurnos va discreta en el pie.
 *
 * El rubro se muestra con su nombre y no con su clave: la columna guarda
 * 'barberia' y 'padel', que es lo que estaba saliendo impreso debajo del
 * nombre del negocio, sin acento y en minúscula.
 *
 * La dirección aparece acá y no más abajo porque la pregunta "¿dónde queda?"
 * se la hace el cliente ANTES de elegir el horario, no después. Hasta hace
 * poco la recibía recién en el email de confirmación, o preguntando por
 * WhatsApp.
 *
 * ─── El botón «Ver mapa» es sólo del celular ───────────────────────────────
 *
 * En pantallas anchas el mapa vive en una columna al costado y este botón no
 * tiene sentido: lo esconde el CSS. Acá abajo igual se dibuja, porque "ancho"
 * lo decide una media query y no este componente; lo que NO se dibuja nunca
 * hasta que alguien toca el botón es el iframe.
 */
export function Cabecera({ negocio }) {
  const inicial = (negocio?.nombre ?? '?').trim().charAt(0).toUpperCase();
  const direccion = negocio?.direccion?.trim();

  // Arranca cerrado y el iframe no existe hasta que se abre. Es la diferencia
  // entre que Google vea a todos los que entran a reservar y que vea sólo a
  // los que quisieron mirar dónde queda.
  const [mapaAbierto, setMapaAbierto] = useState(false);

  return (
    <header className={`cabecera${mapaAbierto ? ' con-mapa-abierto' : ''}`}>
      <div className="cabecera-in">
        <div className="avatar-negocio" aria-hidden="true">{inicial}</div>
        <div className="cabecera-datos">
          <div className="nombre-negocio">{negocio?.nombre ?? 'Reservar turno'}</div>
          {negocio?.rubro && negocio.rubro !== 'otro' && (
            <div className="rubro-negocio">{NOMBRE_DE_RUBRO[negocio.rubro] ?? negocio.rubro}</div>
          )}
          {/* La dirección y sus dos botones van juntos o no va ninguno: quien
              atiende a domicilio la deja vacía y acá no se dibuja nada. */}
          {direccion && (
            <div className="direccion-negocio">
              <span className="direccion-texto">{direccion}</span>
              <a
                className="como-llegar"
                href={linkDeMapa(direccion)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" />
                  <circle cx="12" cy="10" r="2.6" />
                </svg>
                Cómo llegar
                <span className="sr-only"> (se abre en Google Maps)</span>
              </a>
              <button
                type="button"
                className="ver-mapa"
                aria-expanded={mapaAbierto}
                onClick={() => setMapaAbierto((abierto) => !abierto)}
              >
                {mapaAbierto ? 'Ocultar mapa' : 'Ver mapa'}
              </button>
            </div>
          )}
        </div>
      </div>

      {direccion && mapaAbierto && (
        <MarcoDeMapa
          direccion={direccion}
          titulo={`Mapa de ${negocio?.nombre ?? 'el negocio'}, en ${direccion}`}
          className="mapa-en-cabecera"
          perezoso={false}
        />
      )}
    </header>
  );
}
